import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { signInWithGoogle } from "../apis/Signin";
import { getUser } from "./Authservice";

export default function RedirectPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const failed = params.has("error");
  const unavailable = params.get("error") === "configuration";
  const [error, setError] = useState(failed);

  useEffect(() => {
    localStorage.removeItem("usersaarthi");
    if (failed) return;
    const controller = new AbortController();
    axios
      .get("/api/auth/login/success", {
        withCredentials: true,
        signal: controller.signal,
        timeout: 20000,
      })
      .then(({ data }) => {
        if (controller.signal.aborted) return;
        localStorage.setItem("usersaarthi", JSON.stringify(data.user));
        if (!getUser()) throw new Error("Missing Google profile");
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          localStorage.removeItem("usersaarthi");
          setError(true);
        }
      });
    return () => controller.abort();
  }, [failed, navigate]);

  return (
    <main className="auth-page">
      <Link className="brand" to="/">
        saarthi<span>.</span>
      </Link>
      <div className="surface auth-card" role={error ? "alert" : "status"}>
        {!error && <span className="loading-ring" />}
        <p className="eyebrow">YOUR LEARNING JOURNEY</p>
        <h1>
          {unavailable
            ? "Sign-in is unavailable."
            : error
              ? "Let’s try that again."
              : "Getting you settled in."}
        </h1>
        <p>
          {unavailable
            ? "Google sign-in is temporarily unavailable. You can still explore the course library."
            : error
              ? "We couldn’t complete Google sign-in. Please try again in a moment."
              : "Finishing your Google sign-in. Your dashboard is on its way."}
        </p>
        {error && !unavailable && (
          <button className="button button-primary" onClick={signInWithGoogle}>
            Try Google sign-in again
          </button>
        )}
        <Link className="text-link" to="/">
          Back to courses →
        </Link>
      </div>
    </main>
  );
}
